/**
 * HTTP API configuration and error codes
 * Centralized configuration for all HTTP communication
 */

import { env } from '@/env/env';
import { ApiConfig } from './types';

// API Error codes
export enum ApiErrorCode {
    NETWORK_ERROR = 'NETWORK_ERROR',
    TIMEOUT_ERROR = 'TIMEOUT_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
    AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
    NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
    SERVER_ERROR = 'SERVER_ERROR',
    RATE_LIMIT_ERROR = 'RATE_LIMIT_ERROR',
    CSRF_ERROR = 'CSRF_ERROR'
}

// Default HTTP client configuration
export const defaultApiConfig: ApiConfig = {
    // No hardcoded fallback: a missing value must fail loudly (startup
    // validation) instead of silently sending traffic to another environment.
    baseUrl: env('NEXT_PUBLIC_API_BASE_URL') ?? '',
    timeout: 60000, // 60 seconds
    retries: {
        maxAttempts: 3,
        baseDelay: 2000, // 2 seconds
        maxDelay: 10000, // 10 seconds
        backoffFactor: 2
    },
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
};
